export function inr(n) {
  const num = Number(n || 0);
  const hasPaise = Math.round(num * 100) % 100 !== 0;
  return (
    "₹" +
    num.toLocaleString("en-IN", {
      minimumFractionDigits: hasPaise ? 2 : 0,
      maximumFractionDigits: 2,
    })
  );
}

export function fmtDate(d) {
  if (!d) return "";
  const date = new Date(d);
  if (isNaN(date)) return "";
  return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export function fmtDateTime(d) {
  if (!d) return "";
  const date = new Date(d);
  if (isNaN(date)) return "";
  return date.toLocaleString("en-IN", {
    day: "numeric", month: "short", year: "numeric",
    hour: "numeric", minute: "2-digit", hour12: true,
  });
}

export const ORDER_STEPS = ["placed", "packed", "shipped", "delivered"];

export const STATUS_COLORS = {
  placed: "bg-blue-100 text-blue-800",
  packed: "bg-amber-100 text-amber-800",
  shipped: "bg-violet-100 text-violet-800",
  delivered: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-red-100 text-red-700",
  paid: "bg-emerald-100 text-emerald-800",
  pending: "bg-amber-100 text-amber-800",
  cod_pending: "bg-amber-100 text-amber-800",
  refunded: "bg-neutral-200 text-neutral-700",
};
